import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * Tempo limite para requisições (10 segundos)
   */
  private readonly REQUEST_TIMEOUT = 10000;

  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      // Adiciona timeout às requisições
      timeout(this.REQUEST_TIMEOUT),

      // Captura e trata erros
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  /**
   * Trata erros HTTP de forma estruturada
   */
  private handleError(error: any): Observable<never> {
    let errorResponse: any = {
      status: 0,
      statusText: 'Unknown Error',
      message: 'Um erro desconhecido ocorreu',
    };

    // Erro de rede (backend offline ou sem conexão)
    if (error.status === 0) {
      errorResponse = {
        status: 0,
        statusText: 'Network Error',
        message: 'Não foi possível conectar ao servidor. Verifique se o backend está rodando.',
        code: 'NETWORK_ERROR',
      };
    }
    // Timeout
    else if (error.name === 'TimeoutError') {
      errorResponse = {
        status: 408,
        statusText: 'Request Timeout',
        message: 'A requisição expirou. Tente novamente.',
        code: 'TIMEOUT_ERROR',
      };
    }
    // Erro HTTP padrão
    else if (error instanceof HttpErrorResponse) {
      // Se o error.error é uma string, usa-o diretamente como message
      let message = error.message;

      if (typeof error.error === 'string') {
        message = error.error;
      } else if (error.error?.message) {
        message = error.error.message;
      }

      errorResponse = {
        status: error.status,
        statusText: error.statusText,
        message: message,
        body: error.error,
      };

      // Se for 403, redireciona para forbidden
      if (error.status === 403) {
        try {
          this.router.navigate(['/forbidden']);
        } catch (e) {
          console.warn('Falha ao navegar para /forbidden', e);
        }
      }
    }

    // Log do erro em desenvolvimento
    if (!environment.production) {
      console.group('🔴 HTTP ERROR INTERCEPTED');
      console.error('Status:', errorResponse.status);
      console.error('Message:', errorResponse.message);
      console.error('Full Error:', error);
      console.groupEnd();
    }

    return throwError(() => errorResponse);
  }
}

// Dummy environment para desenvolvimento
const environment = { production: false };
